<main class="page-container configuration-page">
  <app-page-header
    title="Configuración del sistema"
    description="Administra los parámetros generales y consulta el estado de la plataforma."
  >
    <app-button variant="primary" size="large" (clicked)="save()" [loading]="saving()">
      <i button-icon class="fa-solid fa-floppy-disk"></i> Guardar cambios
    </app-button>
  </app-page-header>

  @if (loading()) {
    <section class="state-message">
      <app-loading label="Cargando configuración..." [fullscreen]="true"></app-loading>
    </section>
  } @else {
    <section class="data-section-card configuration-container">
      @if (errorMessage()) {
        <app-alert-banner
          type="error"
          title="No se pudo cargar la configuración"
          [message]="errorMessage()"
        />
      }
      @if (successMessage()) {
        <app-alert-banner
          type="success"
          title="Configuración actualizada"
          [message]="successMessage()"
        />
      }

      <div class="configuration-grid">
        <section class="configuration-card">
          <div class="section-heading">
            <span class="section-icon"><i class="fa-solid fa-sliders"></i></span>
            <div>
              <h2>Parámetros generales</h2>
              <p>Valores predeterminados utilizados por la plataforma.</p>
            </div>
          </div>
          <div class="form-grid">
            <label
              >Moneda<input type="text" maxlength="10" [(ngModel)]="configuration.moneda"
            /></label>
            <label
              >Zona horaria<input
                type="text"
                maxlength="80"
                [(ngModel)]="configuration.zonaHoraria"
            /></label>
            <label for="formatoFecha"
              >Formato de fecha
              <app-select [(ngModel)]="configuration.formatoFecha" [options]="dateFormatOptions">
              </app-select>
            </label>
          </div>
          <div class="configuration-actions">
            <app-button variant="text" size="small" (clicked)="restoreDefaults()">
              Restaurar valores predeterminados
            </app-button>
          </div>
          @if (lastUpdated) {
            <p class="updated">
              Última actualización: {{ lastUpdated | date: 'dd/MM/yyyy HH:mm' }}
            </p>
          }
        </section>

        <section class="status-card">
          <div class="section-heading">
            <span class="section-icon status-icon"><i class="fa-solid fa-heart-pulse"></i></span>
            <div>
              <h2>Estado del sistema</h2>
              <p>Disponibilidad de los servicios principales.</p>
            </div>
            <app-button
              variant="text"
              size="small"
              (clicked)="checkStatus()"
              [loading]="checkingStatus()"
              ariaLabel="Actualizar estado"
              ><i button-icon class="fa-solid fa-rotate-right"></i
            ></app-button>
          </div>
          @if (statusError()) {
            <app-alert-banner
              type="error"
              title="No se pudo consultar el estado"
              [message]="statusError()"
            />
          }
          @if (systemStatus(); as status) {
            <div class="system-summary" [class.degraded]="status.estado !== 'Operativo'">
              <span class="status-dot"></span><strong>{{ status.estado }}</strong
              ><span>{{ status.ambiente }}</span>
            </div>
            <div class="service-list">
              @for (service of status.servicios; track service.nombre) {
                <div class="service-row">
                  <span
                    ><i
                      class="fa-solid fa-circle"
                      [class.service-ok]="service.estado === 'Operativo'"
                    ></i
                    >{{ service.nombre }}</span
                  ><strong>{{ service.estado }}</strong
                  ><small>{{ service.tiempoRespuestaMs }} ms</small>
                </div>
              }
            </div>
            <p class="updated">
              Versión {{ status.version }} · Verificado:
              {{ status.verificadoEn | date: 'dd/MM/yyyy HH:mm:ss' }}
            </p>
          }
        </section>
      </div>
    </section>
  }
</main>
